<div class="mt-1 col-12 text-center bottom-segment">
    <small>{{ 'LAYOUT_ONE.plane_change_in' | translate }} {{ segment.destination.cityName }} (  {{ segment.destination.iata }}  ) </small>
    <small class="pull-right stop-duration">{{ 'LAYOUT_ONE.stop_of' | translate }} {{ segment.stopDuration }}</small>
</div>
